import React, { useCallback, useEffect, useState } from 'react';
import { MAX_PASSWORD_LENGTH, MIN_PASSWORD_LENGTH } from '../../../../../data/constants/user';
import { useI18n } from '../../../../../data/hooks/i18nHooks';
import Button from '../../../../elements/Button/Button';
import { dialogAlert } from '../../../../elements/Dialog/dialogs';
import Input from '../../../../elements/forms/Input';
import PasswordRequirements from './PasswordRequirements/PasswordRequirements';

const RequestNewPassword = (props) => {
    const { oldPassword, onChange } = props,
        [newPassword, setNewPassword] = useState(''),
        [confirmPassword, setConfirmPassword] = useState(''),
        [updatingPassword, setUpdatingPassword] = useState(false),
        i18n = useI18n();

    const handleSubmit = useCallback(
        (e) => {
            e.preventDefault();
            e.stopPropagation();

            if (!updatingPassword) {
                setUpdatingPassword(true);
            }
        },
        [oldPassword, newPassword]
    );

    useEffect(() => {
        if (updatingPassword) {
            let waiting = true;

            async function updatePassword() {
                if (!newPassword.length || !confirmPassword.length) {
                    await dialogAlert(i18n['message.allfieldsrequired']);
                } else if (newPassword.length < MIN_PASSWORD_LENGTH) {
                    await dialogAlert(i18n['message.passwordlengthexceeds']);
                } else if (newPassword != confirmPassword) {
                    await dialogAlert(i18n["label.both.password.dosn't.match"]);
                } else {
                    await updatePassword();
                    return;
                }
                setUpdatingPassword(false);

                async function updatePassword() {
                    try {
                        let response = await app.api.users.changePassword(oldPassword, newPassword);
                        await dialogAlert(i18n['label.password.successfully.update']);
                        if (waiting) {
                            app.history.push('..');
                        }
                    } catch (err) {
                        if (err?.response?.data?.error_details?.old_password) {
                            await dialogAlert(i18n['message.invalid-password']);
                            app.history.push('..');
                        } else if (err?.response?.data?.error_details?.password) {
                            await dialogAlert(err?.response?.data?.error_details?.password[0]);
                        } else {
                            await dialogAlert(i18n['message.fail-change-password']);
                        }
                        if (waiting) setUpdatingPassword(false);
                    }
                }
            }
            updatePassword();

            return () => (waiting = false);
        }
    }, [updatingPassword]);

    return (
        <form onSubmit={handleSubmit}>
            <PasswordRequirements className="indent content" />
            <div className="indent content" style={{ minHeight: 200 }}>
                <Input
                    type="password"
                    label={i18n['label.new.password']}
                    value={newPassword}
                    onChange={setNewPassword}
                    autoFocus
                    name="new-password"
                    autoComplete="new-password"
                    minLength={MIN_PASSWORD_LENGTH}
                    maxLength={MAX_PASSWORD_LENGTH}
                />
                <Input type="password" label={i18n['label.repeat.password']} value={confirmPassword} onChange={setConfirmPassword} name="confirm-password" />
            </div>
            <div className="content">
                <Button type="submit" primary block>
                    {i18n['label.editprofile.store']}
                </Button>
            </div>
        </form>
    );
};

export default RequestNewPassword;
